module.exports = __webpack_public_path__ + "img/17mi.f4fc547c.jpg";